import React, {Component} from 'react';

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions.js';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import CONFIG from './../../SYSTEM/Config.js'

import { Request } from "./../../SYSTEM/Request"


function mapStateToProps(state) {
    return {
        SET_OWN_PRICE: state.SET_OWN_PRICE,
        USER: state.USER
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}

class OwnPriceModal extends Component {

    /// CONSTRUCTOR ///
    constructor(props) {
        super(props);
        this.state = {
            SEND_DATA: false,
            PRICE: 0
        }
        console.log(this.props.SET_OWN_PRICE)
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.SET_OWN_PRICE !== prevProps.SET_OWN_PRICE) {
            if (window.innerWidth < 1200) {
                if (!this.props.SET_OWN_PRICE) {
                    document.body.classList.remove("modal-open");
                    document.documentElement.scrollTop = this.OFFSET;
                    this.setState({PRICE: 0, SEND_DATA: false})
                } else {
                    this.OFFSET = window.pageYOffset || document.documentElement.scrollTop;
                    document.body.classList.add("modal-open");
                }
            }
        }
    }

    sendRequest = async () => {
        let SEND_DATA = {
            action: 'supplierSendPriceOnProduct',
            supplier_apikey: this.props.USER.supplier_apikey,
            id: this.props.SET_OWN_PRICE.id,
            price: this.state.PRICE
        };
        try {
            let data = await Request(SEND_DATA, CONFIG.API_GATE);
            if (data !== false) {
                this.setState({SEND_DATA: true});
            }
        } catch (error) {
        }
    }

    renderContent = () => {
        if (this.props.SET_OWN_PRICE) {
            if(this.state.SEND_DATA){
                return (
                    <div className="marketing_modal_holder">
                        <img className="blue_cross" src="/system_images/blue_cross.png" onClick={()=> {this.props.setOwnPrice(false); this.setState({SEND_DATA: false}) }}/>
                        <div className="marketing_modal_text_after_send_blue">Спасибо!</div>
                        <div className="marketing_modal_text_after_send">Заявка отправлена, мы рассмотрим ваше предложение и свяжемся с вами!</div>
                    </div>
                )
            }else{
                return (
                    <div className="marketing_modal_holder">
                        <img className="blue_cross" src="/system_images/blue_cross.png" onClick={()=> this.props.setOwnPrice(false)}/>
                        <div className="marketing_modal_text"><strong>Укажите цену за 1{this.props.SET_OWN_PRICE.ed_izm} {this.props.SET_OWN_PRICE.title}</strong></div>
                        <div>
                            <div className="filter_element"><input type="number" placehodler="Цена" value={this.state.PRICE} onChange={ (input) => this.setState({PRICE: input.target.value}) } /></div>
                        </div>

                        <div className="marketing_model_blue_button" onClick={() => this.sendRequest()}>Отправить цену</div>
                    </div>
                )
            }

        }
    }

    render() {
        if (this.props.SET_OWN_PRICE) {
            return (
                <div className="modal">
                    <div className="modal-overlay" onClick={() => this.props.setOwnPrice(false)}>
                    </div>
                    <div className="modal-box">
                        {this.renderContent()}
                    </div>
                </div>
            );
        } else {
            return false;
        }
    }
}

export default connect(
    mapStateToProps, mapDispatchToProps
)(OwnPriceModal);